import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import styles from 'styles/jss/original/components/menus/menuModalList';
import MenuModalListItem from '@/components/menus/MenuModalListItem';
import { IMenuTaxonomy } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  title: string;
  taxonomyList: IMenuTaxonomy[];
  onClick: () => void;
};

const MenuModalList: React.FC<ComponentProps> = ({ title, taxonomyList, onClick }) => {
  const classes = useStyles();
  return (
    <>
      <h5 className={classes.title}>{title}</h5>
      <GridContainer>
        {taxonomyList.map((taxonomy, index) => {
          return (
            <MenuModalListItem
              taxonomy={taxonomy}
              onRequestClick={onClick}
              key={`taxonomy-item-${index.toString()}`}
            />
          );
        })}
      </GridContainer>
    </>
  );
};

export default MenuModalList;
